/*
 * (c) Copyright, 2019, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import _ from 'lodash'
import React from 'react'
import { Button } from 'react-bootstrap'

interface TextLinkButtonProps {
  action?: () => void
  title?: string
  children: React.ReactNode
  className?: string
}

const TextLinkButton: React.FC<TextLinkButtonProps> = ({ action, title, children, className = '' }) => {
  return (
    <Button
      className={'text-link-btn ' + className}
      variant="link"
      title={title}
      onClick={() => {
        if (_.isFunction(action)) {
          action()
        }
      }}
    >
      {children}
    </Button>
  )
}

export default TextLinkButton
